import { useParams } from 'react-router';
import { ReactFlowProvider } from '@xyflow/react';
import { GraphProvider } from '../../context';
import { GraphErrorBoundary } from '../../molecules';
import { GraphView } from '../graph-view';

export const GraphEditor = () => {
  const { entryId, graphId } = useParams();

  if (!entryId) {
    // The application incorrectly routed to the graph editor.
    return <GraphErrorBoundary />;
  }

  return (
    <GraphProvider entryId={entryId} graphId={graphId}>
      <ReactFlowProvider>
        <GraphView />
      </ReactFlowProvider>
    </GraphProvider>
  );
};
